// eslint-disable-next-line import/prefer-default-export
export enum RouteNames {
  DocumentResult = 'Document',
  DuplicateJob = 'Duplicate Job',
  Selection = 'Selection',
  SelectionQuery = 'Selection Query',
  Summaries = 'Summaries',
  Assistant = 'Assistant',
}
